import React from "react";
import { connect } from "react-redux";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import Div100vh from "react-div-100vh";

import { TopNavigation, BottomNavigation } from "./components/Navigation";
import {
  Packages,
  Lockers,
  Account,
  Login,
  CreateAccount,
  PinView,
  Dashboard
} from "./views";
import { validateThenLogin } from "./actions/auth";
import { fetchUserData } from "./actions/userData";

const styles = {
  mainDiv: {
    display: "flex",
    flexDirection: "column",
    height: "100rvh"
  }
};

class App extends React.Component {
  state = {
    showLoadingScreen: true
  };

  async componentDidMount() {
    await this.props.validateThenLogin();
  }

  async componentWillReceiveProps(nextProps) {
    // check if redux state updated
    if (
      this.props.auth !== nextProps.auth ||
      this.props.userData !== nextProps.userData
    ) {
      // if not fetched yet
      if (nextProps.auth.loggedIn && !nextProps.userData.fetched) {
        this.setState({ showLoadingScreen: true });
        await this.props.fetchUserData();
        this.setState({ showLoadingScreen: false });
      } else {
        this.setState({
          showLoadingScreen: false
        });
      }
    }
  }

  render() {
    // stupid bug where 'vh' is too large needs fixing
    let viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
    );

    if (this.state.showLoadingScreen)
      return (
        <Div100vh
          style={{
            ...styles.mainDiv,
            justifyContent: "center",
            backgroundColor: "#FDFDFD"
          }}
        >
          <img
            src={require("./assets/loading_box.gif")}
            alt="loading gif"
            width="100%"
          />
        </Div100vh>
      );

    return (
      <Router>
        {this.props.auth.loggedIn ? (
          <div>
            {this.props.userData.account.isMerchant ? (
              <Div100vh style={styles.mainDiv}>
                <TopNavigation />
                <Switch>
                  <Route path="/dropoff" component={PinView} />
                  <Route path="/home" component={Dashboard} />
                  <Route
                    path="/pickup"
                    render={props => <PinView {...props} isPickup />}
                  />
                  <Route render={() => <Redirect to="/home" />} />
                </Switch>
                <BottomNavigation isMerchant />
              </Div100vh>
            ) : (
              <Div100vh style={styles.mainDiv}>
                <TopNavigation />
                <Switch>
                  <Route path="/packages" component={Packages} />
                  <Route path="/lockers" component={Lockers} />
                  <Route path="/account" component={Account} />
                  <Route render={() => <Redirect to="/packages/ready" />} />
                </Switch>
                <BottomNavigation />
              </Div100vh>
            )}
          </div>
        ) : (
          <Div100vh style={styles.mainDiv}>
            <Switch>
              <Route path="/create/account" component={CreateAccount} />
              <Route component={Login} />
            </Switch>
          </Div100vh>
        )}
      </Router>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  validateThenLogin: () => dispatch(validateThenLogin()),
  fetchUserData: () => dispatch(fetchUserData())
});

const mapStateToProps = state => ({
  ...state
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
